module.exports = __webpack_public_path__ + "img/bg-banner-bz.876ae8ab.png";